import React, { usecontext, useContext } from "react"
import { Link } from "react-router-dom"
import DispatchContext from "./DispatchContext"
import StateContext from "./StateContext"
import ReactTooltip from "react-tooltip"

const HeaderLoggedIn = (props) => {
  const appDispatch = useContext(DispatchContext)
  const appState = useContext(StateContext)

  function handleLoggedout() {
    appDispatch({ type: "logout" })
  }

  function handleSearch(e) {
    e.preventDefault()
    appDispatch({ type: "openSearch" })
  }

  return (
    <div className="flex-row my-3 my-md-0">
      <a data-for="search" data-tip="Search" onClick={handleSearch} href="#" className="text-white mr-2 header-search-icon">
        <i className="fa fa-search" aria-hidden="true"></i>
      </a>
      <ReactTooltip place="bottom" id="search" className="custom-tooltip" />
      <span onClick={() => appDispatch({ type: "toggleChat" })} data-for="chat" data-tip="Chat" className={"mr-2 header-chat-icon " + (appState.unreadChatCount ? "text-danger" : "text-white")}>
        {"  "}
        <i className="fa fa-comment" aria-hidden="true"></i>
        {appState.unreadChatCount ? <span className="chat-count-badge text-white">{appState.unreadChatCount < 10 ? appState.unreadChatCount : "9+"} </span> : ""}
      </span>
      <ReactTooltip place="bottom" id="chat" className="custom-tooltip" />
      {"  "}
      <Link data-for="profile" data-tip="My Profile" to={`/profile/${appState.user.username}`} className="mr-2">
        <img className="small-header-avatar" src="https://secure.gravatar.com/avatar/dde9ede862cc8f7e25ce54a74812cd58" />
      </Link>
      <ReactTooltip place="bottom" id="profile" className="custom-tooltip" />
      {"  "}{" "}
      <Link className="btn btn-sm btn-success mr-2" to="/create-post">
        Create Post
      </Link>
      {"  "}{" "}
      <button onClick={handleLoggedout} className="btn btn-sm btn-secondary">
        Sign Out
      </button>
    </div>
  )
}

export default HeaderLoggedIn
